import {OccurrenceProps} from 'modules/orders/types';
import useApiQuery from 'shared/hooks/use-api-query';

const useDeliveryManBillingOccurrences = (deliveryManBillingId: string) => {
  return useApiQuery<OccurrenceProps[]>({
    url: `/delivery-man-billings/${deliveryManBillingId}/occurrences`,
  });
};

export default useDeliveryManBillingOccurrences;
